export function defineStatus(vehicleStatus: any) {
  switch (vehicleStatus) {
    case 'Nao Aplica':
    case '--':
    case '':
      return 'N/A'
    default:
      return vehicleStatus
  }
}

export function normalizeAndReplace(str: string) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s/g, '')
}

export function formatRealTimeDifference(dataInicio: any, dataFim?: any) {
  const startDate = new Date(dataInicio)
  const endDate = new Date(dataFim)
  const difference = endDate.getTime() - startDate.getTime()
  const seconds = Math.floor(difference / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)
  const years = Math.floor(days / 365)
  const months = Math.floor((days % 365) / 30)
  let formattedString = ''
  if (!dataFim) {
    formattedString = 'Contrato vigente'
  } else if (years >= 1) {
    formattedString += `${years} ano${years > 1 ? 's' : ''}`
    if (months >= 1) {
      formattedString += ` e ${months} mês${months > 1 ? 'es' : ''}`
    }
  } else if (months >= 1) {
    formattedString += `${months} mês${months > 1 ? 'es' : ''}`
  } else {
    formattedString = 'Não há tempo de contrato'
  }
  return formattedString
}

export const convertOptionsSelect = (option: string) => {
  switch (option) {
    case 'NaoAplica':
      return 'Não Aplica'
    case 'Automatico':
      return 'Automático'
    case 'Semiautomatico':
      return 'Semiautomático'
    case 'Hidraulica':
      return 'Hidráulica'
    case 'Eletrico':
      return 'Elétrico'
    case 'Eletrica':
      return 'Elétrica'
    case 'Mecanica':
      return 'Mecânica'
    case 'Eletrica Hidraulica':
      return 'Elétrica Hidráulica'
    case 'NãoOperacional':
      return 'Não operacional'
    case 'OperacionalA':
      return 'Operacional A'
    case 'OperacionalB':
      return 'Operacional B'
    case 'OperacionalC':
      return 'Operacional C'
    case 'OperacionalD':
      return 'Operacional D'
    default:
      return option
  }
}

export const fuelOptions = [
  'Não Aplica',
  'Gasolina',
  'Flex',
  'Diesel',
  'Etanol',
  'Elétrico',
  'Hibrido'
]

export const transmissionOptions = [
  'Não Aplica',
  'Manual',
  'Automático',
  'Semiautomático',
  'CVT',
  'SAT'
]

export const steeringOptions = [
  'Não Aplica',
  'Mecânica',
  'Hidráulica',
  'Elétrica',
  'Elétrica Hidráulica'
]

export const counterOptions = ['KM', 'Hora']
export const originOptions = ['Nacional', 'Importado']
export const statusOptions = [
  'Operacional A',
  'Operacional B',
  'Operacional C',
  'Operacional D',
  'Não Operacional',
  'Avariado',
  'Sinistrado',
  'PT',
  'Não se aplica'
]
export const useOptions = ['Trabalho', 'Particular', 'Aluguel']
